// src/components/AdminFooter.js
import React from 'react';
import '../styles/AdminPanel.css';

const AdminFooter = () => {
  return (
    <div className="admin-footer-container">
      <p>&copy; 2024 IKUD. All rights reserved.</p>
      <a href="https://ikud.org.tr/ikud/" target="_blank" rel="noopener noreferrer">
        IKUD Resmi Sitesi
      </a>
    </div>
  );
};

export default AdminFooter;
